import {Deserializable} from "./deserializable.model";

export class JobStatus {

  job_status_id: number;
  job_status_description: string;
  job_status_name: string;
  is_active: string;


  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): JobStatus {
    Object.assign(this, input);

    return this;
  }


}
